module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Time_16"],"path":[{"$":{"d":"M8,1.5A6.5,6.5,0,1,1,1.5,8,6.51,6.51,0,0,1,8,1.5M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm3.64,7.06-1-1.34L8.27,7.53,5.17,4,3.88,5.07,8,9.87Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Time_16.svg
// module id = xrlp
// module chunks = 1